function createObjectMethods(makeObject) {
  function object(value) {
    return makeObject(value);
  }
  object.system = () => object("0x5");
  object.clock = () => object("0x6");
  object.random = () => object("0x8");
  object.denyList = () => object("0x403");
  return object;
}
export {
  createObjectMethods
};
//# sourceMappingURL=object.js.map
